<script setup lang="ts">
interface Props {
  text?: string
  fullWidth?: boolean
  noBackground?: boolean
}

const { text = "", fullWidth = false, noBackground = false } = defineProps<Props>();
</script>

<template>
  <div
    class="inline-flex items-center px-2.5 h-[35px] w-full max-w-[1050px] rounded-md bg-gray-50 dark:bg-gray-800 text-gray-800 dark:text-gray-100 font-bold text-sm"
    :class="[
      fullWidth && 'max-w-full',
      noBackground && 'bg-transparent',
    ]"
  >
    {{ text }}<slot />
  </div>
</template>
